module.exports = __webpack_public_path__ + "staticVue/img/true-icon.037cddb5.png";